import React from "react";

// Redux Connect H O C
import { connect } from "react-redux";

import { NavLink } from "react-router-dom";
// CSS
import "../../../css/shared/CreateFeed.css";

const Notice = props => {
  const { auth } = props;
  console.log(props);

  const note = auth.uid ? null : (
    <div>
      <p id="note">
        Please note that creating a new article without registering account is
        not permissible. Please{" "}
        <NavLink className="Links" to="/signin">
          Sign In
        </NavLink>
        &nbsp;or&nbsp;
        <NavLink className="Links" to="/signup">
          Sign Up
        </NavLink>
        &nbsp;before creating an article.
      </p>
    </div>
  );

  return <div>{note}</div>;
};

const mapStateToProps = state => {
  console.log(state);
  return {
    auth: state.firebase.auth
  };
};

export default connect(mapStateToProps)(Notice);
